import { defineMessages } from 'react-intl';

export default defineMessages({
    insuranceHistoryTitle: {
        id: 'wmic-pe-capability-gateway-policyrenewal-ho-react.pages.WMICHOPolicyRenewalInsuranceHistory.WMICHOPolicyRenewalInsuranceHistoryPage.Title',
        defaultMessage: 'Insurance History'
    },
    policies: {
        id: 'wmic-pe-capability-gateway-policyrenewal-ho-react.WMICHOPolicyRenewalInsuranceHistory.Policies',
        defaultMessage: 'Policies'
    },
    lossHistoryTitle: {
        id: 'wmic-pe-capability-gateway-policyrenewal-ho-react.WMICHOPolicyRenewalInsuranceHistory.Loss History',
        defaultMessage: 'Loss History'
    },
    creditConsent: {
        id: 'wmic-pe-capability-gateway-policyrenewal-ho-react.WMICHOPolicyRenewalInsuranceHistory.Credit Consent',
        defaultMessage: 'Credit Consent'
    },
    brokerInfoTitle: {
        id: 'wmic-pe-capability-gateway-policyrenewal-ho-react.WMICHOPolicyRenewalInsuranceHistory.Broker',
        defaultMessage: 'Broker'
    },
    saveInsuranceHistory: {
        id: 'wmic-pe-capability-gateway-policyrenewal-ho-react.WMICHOPolicyRenewalInsuranceHistory.saveInsuranceHistory',
        defaultMessage: 'Save Insurance History'
    },
});